//allows you to use conditional expressions
//used on book page
resortModule.filter('iif', function () {
    return function (input, trueValue, falseValue) {
        return input ? trueValue : falseValue;
   };
});